import { z } from 'src/lib';
import { OperacionCFFields } from './fields';
import { schemaEntityWithId } from 'src/types';

export const schemaOperacionCF = z
    .object({
        [OperacionCFFields.CodPais]: z.number(),
        [OperacionCFFields.NombrePais]: z.string(),
        [OperacionCFFields.CodUnidadNegocio]: z.number().nullable(),
        [OperacionCFFields.UnidadNegocio]: z.string().nullable(),
        [OperacionCFFields.CodSectorComercial]: z.number().nullable(),
        [OperacionCFFields.SectorComercial]: z.string().nullable(),
        [OperacionCFFields.FechaSolicitud]: z.coerce.date().nullable(),
        
        [OperacionCFFields.RazonSocial]: z.string().nullable(),
        [OperacionCFFields.NumeroCuenta]: z.string().nullable(),
        [OperacionCFFields.CodOperacionCFTipo]: z.number(),
        [OperacionCFFields.CodEstado]: z.number(),
        [OperacionCFFields.DescEstado]: z.string(),
        [OperacionCFFields.InformacionAdicionalEmpresa]: z.string().nullable(),

        [OperacionCFFields.SuccessFee]: z.string().nullable(),
        [OperacionCFFields.MontoMinimoSuccess]: z.string().nullable(),
        [OperacionCFFields.CantMesesRetainer]: z.string().nullable(),
        [OperacionCFFields.MontoRetainerMensual]: z.string().nullable(),

        [OperacionCFFields.AcreditacionRetainerMensual]: z.boolean().nullable(),
        [OperacionCFFields.Exclusividad]: z.boolean().nullable(),

        [OperacionCFFields.FechaAprobacion]: z.coerce.date().nullable(),
        [OperacionCFFields.FechaAlta]: z.coerce.date().nullable(),
        [OperacionCFFields.IdUsuarioAlta]: z.number(),
        [OperacionCFFields.NombreUsuarioAlta]: z.string(),
        [OperacionCFFields.ApellidoUsuarioAlta]: z.string(),
        [OperacionCFFields.IdUsuarioUltMod]: z.number().nullable(),
        
        [OperacionCFFields.EstadoFinalizado]: z.boolean(),
        [OperacionCFFields.PermiteEditarOperacion]: z.boolean(),
        [OperacionCFFields.PermiteEliminarOperacion]: z.boolean(),
        [OperacionCFFields.IdMensaje]: z.number().nullable(),
    })
    .merge(schemaEntityWithId);

export type OperacionCF = z.infer<typeof schemaOperacionCF>;